import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {canUseLoginLink} from 'src/openapi/admin/apis/LoginLinkControllerApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useLoginActionAvailable = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        canUseLoginLink({userId}, {signal}),
    ), [userId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {canLogin: false},
        getDispatchAction,
    });
};
